// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"ActionReplays_sliderContainer__3Rlsd","actionReplayItem":"ActionReplays_actionReplayItem__2paU5"};